































import { Vue, Component, Prop } from 'vue-property-decorator';
import NavBar from '../components/common/NavBar.vue';
import InputField from '../components/common/inputs/InputField.vue';
import Button from '../components/common/inputs/Button.vue';
import { Technology } from '@/store/modules/commonInterfaces';
import { CommonModule } from '@/store/modules/common';
import EditIcon from '../components/icons/EditIcon.vue';
import DeleteIcon from '../components/icons/DeleteIcon.vue';

@Component({
  components: {
    NavBar,
    InputField,
    Button,
    EditIcon,
    DeleteIcon
  }
})
export default class ManageTechnologies extends Vue {
  newTechnology = '';
  editing: number | null = null;

  get technologies() {
    return CommonModule.technologies;
  }

  mounted() {
    this.load();
  }

  async load() {
    CommonModule.loadTechnologies();
  }

  edit(technology: Technology) {
    if (!technology.name) {
      return;
    }
    CommonModule.editTechnology(technology);
    this.editing = null;
  }

  remove(id: number) {
    if (confirm('Er du sikker?')) {
      CommonModule.removeTechnology(id);
    }
  }

  async add() {
    if (!this.newTechnology) {
      return;
    }

    const name = this.newTechnology;

    this.newTechnology = '';

    await CommonModule.addTechnology(name);
  }
}
